import * as React from 'react';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';

function CircularProgressWithLabel(props) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress  style={{'color': '#23b4c3'}} size="5rem" variant="determinate" {...props} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography variant="caption" component="div" style={{'fontWeight': '500','fontSize':'22px'}} color="#ffffff">
          {`${Math.round(props.value)}%`}
        </Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired,
};

export default function CircularWithValueLabel() {
  const { workspaceDataSaveLoading } = useSelector((state) => state.workspaceData);
  const [progress, setProgress] = useState(10);

  useEffect(() => {
    let timer;

    const setTimer = () => {
      if (!workspaceDataSaveLoading) {
        clearInterval(timer);
        setProgress(10);
      } else {
        setProgress(10);
        timer = setInterval(() => {
          setProgress((prevProgress) => (prevProgress >= 90 ? 90 : prevProgress + 10));
        }, 500);
      }
    };

    if (workspaceDataSaveLoading) {
        setTimer();
    } else {
      setProgress(10); 
    }

    return () => {
      clearInterval(timer); 
    };
  }, [workspaceDataSaveLoading]);

  return <CircularProgressWithLabel value={progress} />;
}
